<template>
  <section class="tables">
    <div class="page-header">
      <h3 class="page-title">All Users</h3>
      <!-- <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <a href="javascript:void(0);">Table</a>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            Advanced Table
          </li>
        </ol>
      </nav> -->
    </div>
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title"></h4>
            <div class="float-right">
              <!-- search field -->
              <b-input
                v-model="filter"
                placeholder="Search User"
                id="user-search"
                style="padding: 10px"
              ></b-input>
            </div>
            <b-table
              :items="items"
              id="table-list"
              responsive
              :per-page="perPage"
              :current-page="currentPage"
              :fields="fields"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              show-empty
              :filter="filter"
              striped
              hover
            >
              <template #cell(name)="data">
                <!-- name & profile -->
                <img :src="data.item.profile" class="mr-2" alt="image" />
                {{ data.item.name }}
              </template>

              <!-- when no item found -->
              <template #empty="">
                <p class="text-muted text-center">{{ noItems }}</p>
              </template>

              <!-- status -->
              <template v-slot:cell(status)="data">
                <!-- <span v-html="data.value"></span> -->
                <toggle-button
                  @change="changeStatus(data.item)"
                  :value="data.item.status == 'Active'"
                />
              </template>

              <template v-slot:cell(action)="data">
                <!-- Actions -->
                <router-link
                  :to="{ name: 'user-details', params: { id: data.item.id } }"
                >
                  <i
                    class="mr-2 mdi mdi-eye orange-button icon-sm p-2 rounded"
                  ></i>
                </router-link>
                <!-- <i
                  @click="view(data.item.id)"
                  :ref="'btn' + data.index"
                  class="mr-2 mdi mdi-eye text-muted icon-sm"
                ></i> -->
                <!-- <i
                  v-b-modal.modallg
                  @click="edit(data.item.id)"
                  :ref="'btn' + data.index"
                  class="mr-2 mdi mdi-pencil text-muted icon-sm"
                ></i> -->
                <!-- <i
                  @click="deleteItem(data.item.id)"
                  :ref="'btnDelete' + data.index"
                  class="mr-2 mdi orange-button mdi-delete icon-sm p-2 rounded"
                ></i> -->
                <span v-html="data.value"></span>
              </template>
            </b-table>
            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              aria-controls="table-list"
              align="right"
            >
            </b-pagination>
          </div>
        </div>
      </div>
    </div>
    <div></div>
  </section>
</template>
<script>
import Vue from "vue";
import SortedTablePlugin from "vue-sorted-table";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import Swal from "sweetalert2";
import API from "../../../config/api";
import { endpoints } from "../../../config/endpoints";

Vue.use(SortedTablePlugin, {
  ascIcon: '<i class="mdi mdi-arrow-down"></i>',
  descIcon: '<i class="mdi mdi-arrow-up"></i>',
});

export default {
  data: function () {
    return {
      // sortBy: "name",
      perPage: 10,
      currentPage: 1,
      sortDesc: false,
      sortByFormatted: true,
      filterByFormatted: true,
      filter: "",
      sortable: true,
      fields: [
        { key: "name", sortable: true },
        { key: "email", sortable: true },
        // { key: 'phone', sortable: true },
        // { key: "role", sortable: true },
        { key: "status", sortable: true },
        { key: "created_at", sortable: true },
        { key: "action", sortable: true },
      ],
      items: [],
      noItems: null,
    };
  },
  computed: {
    ...mapGetters(["getUsers", "getDefaultImage", "getImageUrl"]),
    rows() {
      return this.items.length;
    },
  },
  methods: {
    ...mapActions(["fetchUsers", "fetchUserDetails", "deleteUser"]),
    setItems(data) {
      data.forEach((element) => {
        let obj = {};
        let baseUrl = "https://greenboom-bucket.s3.us-east-2.amazonaws.com/";
        obj.id = element.id;
        obj.name = element.name;
        // obj.phone = element.phone;
        obj.profile =
          element.profile_image == null
            ? this.getDefaultImage
            : this.getImageUrl + "/" + element.profile_image;
        obj.email = element.email;
        // obj.role = element.role?.name ?? "DELETED";
        obj.status = element.status;
        // obj.status = `<label class="badge ${
        //   element.status === "Active" ? "badge-success" : "badge-danger"
        // }">${element.status}</label>`;

        obj.role_id = element.role?.id;
        obj.status_id = element.status?.id;
        obj.created_at = moment(element.created_at).format(
          "dddd, MMMM Do YYYY"
        );
        this.items.push(obj);
      });
    },
    async view(itemId) {
      await this.fetchUserDetails(itemId);
      console.log(itemId);
    },
    async deleteItem(itemId) {
      console.log(itemId);
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to recover this user!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "Cancel",
        reverseButtons: true,
      });

      if (result.isConfirmed) {
        try {
          // Perform the deletion operation
          await this.deleteUser(itemId);

          // If the deletion is successful, fetch updated data
          await this.fetchUsers();

          // Update the component's data with the latest data
          this.items = [];
          this.getUsers.length > 0
            ? this.setItems(this.getUsers)
            : (this.noItems = "No User Found.");

          // Show success message
          Swal.fire("Deleted!", "User has been deleted.", "success");
        } catch (error) {
          // Handle any errors during deletion or data fetching
          console.error("Error deleting item or fetching data:", error);
          Swal.fire("Error!", "An error occurred during deletion.", "error");
        }
      }
    },
    async changeStatus(item) {
      try {
        // Note the use of await here
        let result = await API.post(`${endpoints.user.userStatus}/${item.id}`);

        // Check the result or handle the response as needed
        if (result.status === 200) {
          // Toggle the status locally in the items array
          const updatedItems = this.items.map((user) => {
            if (user.id === item.id) {
              user.status = user.status === "Active" ? "Inactive" : "Active";
            }
            return user;
          });

          // Update the items array with the new data
          this.items = updatedItems;

          // Show success message based on the new status
          const successMessage =
            item.status === "Active"
              ? "User successfully unblocked."
              : "User successfully blocked.";

          Swal.fire("Success!", successMessage, "success");
        } else {
          // Handle other status codes or error conditions
          console.error("Error updating user status:", result);
        }
      } catch (error) {
        // Handle any errors during deletion or data fetching
        console.error("Error updating user status:", error);
        Swal.fire("Error!", "An error occurred during status update.", "error");
      }
    },
  },
  async mounted() {
    await this.fetchUsers();
    this.getUsers.length > 0
      ? this.setItems(this.getUsers)
      : (this.noItems = "No User Found.");
  },
};
</script>
<style scoped>
.orange-button {
  background-color: #ff002d;
  /* border-color: orange; */
  color: white;
}
</style>
